<div class="component" *ngIf="isVisible | async">
  <button
    class="export-button"
    [title]="'Export Reports'"
    (click)="openModal()"
    data-automation-e2e-selector="download"
  >
    <i class="fa fa-cloud-download" aria-hidden="true"></i>
  </button>
</div>
